import { render, staticRenderFns } from "./DeliveryPanel.vue?vue&type=template&id=799ac79c&"
import script from "./DeliveryPanel.vue?vue&type=script&lang=js&"
export * from "./DeliveryPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports